
export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-4xl md:text-5xl font-bold mb-8 text-gray-800">
              <strong>会社概要</strong>
            </h3>
            
            <div className="space-y-8">
              <div>
                <h4 className="text-2xl font-bold mb-4 text-gray-800">
                  <a href="#about" className="hover:text-pink-500 transition-colors">
                    株式会社Ｍｓ　Ｐｌａｎｔａｇｅ
                  </a>
                </h4>
                <p className="text-gray-600 leading-relaxed">
                  私たちは、ネイルアートを通じて一人ひとりの個性と美しさを引き出すことを使命としています。
                  性別や年齢を問わず、すべてのお客様に質の高いサービスを提供し、
                  ネイルの楽しさと可能性を広げていきます。
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gradient-to-br from-pink-50 to-pink-100 p-6 rounded-xl">
                  <div className="w-12 h-12 bg-gradient-to-r from-pink-400 to-pink-600 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <h5 className="font-bold text-gray-800 mb-2">所在地</h5>
                  <p className="text-gray-600 text-sm">
                    〒546-0043<br />
                    大阪府大阪市東住吉区<br />
                    駒川3-27-39<br />
                    プレジオールKOMAGAWA２０４
                  </p>
                </div>

                <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-xl">
                  <div className="w-12 h-12 bg-gradient-to-r from-teal-400 to-teal-600 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-building-line text-white text-xl"></i>
                  </div>
                  <h5 className="font-bold text-gray-800 mb-2">事業内容</h5>
                  <ul className="text-gray-600 text-sm space-y-1">
                    <li>• ネイルレッスン・講習</li>
                    <li>• オンラインレッスン</li>
                    <li>• ネイル商品企画・販売</li>
                    <li>• 通信販売事業</li>
                  </ul>
                </div>
              </div>

              <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-8 rounded-xl">
                <h5 className="font-bold text-gray-800 mb-4 text-lg">私たちの想い</h5>
                <p className="text-gray-600 leading-relaxed">
                  ネイルは自己表現の一つの形です。美しい指先は、その人の個性や魅力を引き立て、
                  自信を与えてくれます。私たちは、技術の向上はもちろん、
                  お客様一人ひとりのライフスタイルに寄り添ったサービスを心がけています。
                </p>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative overflow-hidden rounded-2xl shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20nail%20salon%20interior%20with%20modern%20equipment%2C%20comfortable%20seating%2C%20bright%20natural%20lighting%2C%20clean%20and%20organized%20workspace%20with%20nail%20polish%20displays%2C%20tools%2C%20and%20welcoming%20atmosphere%20suitable%20for%20all%20genders&width=600&height=800&seq=salon-interior&orientation=portrait"
                alt="サロン内観"
                title="株式会社Ｍｓ　Ｐｌａｎｔａｇｅ サロン"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-400 to-teal-400 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-800">プロフェッショナル</p>
                  <p className="text-sm text-gray-600">認定技術者在籍</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
